import React from 'react';
import { Icon } from './Icon';

/**
 * CampaignOS button. Ported from D:\campaigning-system\src\components\ui\Button.tsx
 * (cos-* tokens; types stripped). variant: primary | secondary | ghost | danger.
 */
const base =
  'inline-flex items-center justify-center gap-2 rounded-xl font-semibold whitespace-nowrap transition-all duration-200 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50';

const variants = {
  primary:
    'bg-gradient-to-b from-cos-teal-mid to-cos-teal-deep text-white shadow-[0_6px_18px_rgba(8,127,120,0.28)] hover:shadow-cos-teal-glow-lg hover:brightness-[1.04] active:brightness-95',
  secondary:
    'border border-cos-line bg-white/65 text-cos-ink hover:bg-cos-surface-hover hover:border-cos-teal/35 hover:text-cos-teal-deep',
  ghost: 'text-cos-ink-secondary hover:bg-white/60 hover:text-cos-ink',
  danger:
    'border border-cos-status-coral/30 bg-cos-status-coral-bg text-cos-status-coral hover:bg-cos-status-coral hover:text-white',
};

const sizes = {
  sm: 'h-9 px-3 text-[13px]',
  md: 'h-10 px-4 text-sm',
};

export function Button({ variant = 'secondary', size = 'md', icon, iconRight, children, className = '', ...rest }) {
  const iconSize = size === 'sm' ? 'text-[17px]' : 'text-[19px]';
  return (
    // type="button" by default: an action button inside any <form> must never submit it.
    <button type="button" className={[base, variants[variant], sizes[size], className].join(' ')} {...rest}>
      {icon && <Icon name={icon} className={`${iconSize} -ml-0.5`} weight={500} />}
      {children}
      {iconRight && <Icon name={iconRight} className={`${iconSize} -mr-0.5`} weight={500} />}
    </button>
  );
}

export default Button;
